// extracted by mini-css-extract-plugin
export default {"globalLoading":"global-loading__ySOQQQye","spin":"spin__J1QKKpt8"};